import { Controller } from '@hotwired/stimulus'
import { getCookie } from '../utils/get_cookie'

export default class PromoMessageController extends Controller<HTMLElement> {
  static values = {
    utmSlug: String,
  }

  static targets = ['badge', 'fallback']

  declare utmSlugValue: string
  declare readonly hasUtmSlugValue: boolean
  declare readonly hasBadgeTarget: boolean
  declare readonly badgeTarget: HTMLElement
  declare readonly hasFallbackTarget: boolean
  declare readonly fallbackTarget: HTMLElement

  connect(): void {
    if (!this.hasUtmSlugValue) return

    const expectedSlug = this.utmSlugValue.trim().toLowerCase()
    if (expectedSlug.length === 0) return

    const campaignCookieValue = this.readCampaignCookieValue()
    const isMatch =
      campaignCookieValue !== undefined &&
      this.valueMatchesSlug(campaignCookieValue, expectedSlug)

    if (this.hasBadgeTarget) {
      this.badgeTarget.classList.toggle('hidden', !isMatch)

      if (this.hasFallbackTarget) {
        this.fallbackTarget.classList.toggle('hidden', isMatch)
      }

      this.element.classList.remove('invisible')
    } else {
      this.element.classList.toggle('invisible', !isMatch)
    }
  }

  private readCampaignCookieValue(): string | undefined {
    const value = getCookie('utm_campaign')
    if (value !== undefined && value.trim().length > 0) {
      try {
        return decodeURIComponent(value).toLowerCase()
      } catch {
        console.warn(
          `[PromoMessageController] Failed to decode cookie value: ${value}`,
        )
      }
    }

    return undefined
  }

  private valueMatchesSlug(value: string, expectedSlug: string): boolean {
    if (value === expectedSlug) return true

    const valueParts = value
      .split(/[|,\s]+/)
      .map((part) => part.trim())
      .filter((part) => part.length > 0)

    return valueParts.includes(expectedSlug)
  }
}
